<template>
  <div class="fake" v-bind="$attrs">
    <div class="avatar">
      <q-skeleton class="square" size="100%" square animation="fade" />
    </div>
    <div class="right">
      <q-skeleton
        class="square"
        width="100%"
        height="17px"
        square
        animation="fade"
      />
      <q-skeleton
        class="square"
        width="100%"
        height="28px"
        square
        animation="fade"
        style="margin: 8px 0 24px"
      />
      <q-skeleton
        class="square"
        width="100%"
        height="20px"
        square
        animation="fade"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.square {
  background: $grayBg;
  border-radius: 8px;
}
.fake {
  padding: 12px;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  .avatar {
    width: 130px;
    height: 130px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .right {
    padding-left: 12px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  border-top: solid 1px $grayBg;
}
</style>
